import { httpRequest } from "@services/http";

export interface Profile {
  id: number;
  user_id: number;
  email: string;
  first_name: string;
  last_name: string;
  roles: { id: number; name: string }[];
  is_active: boolean;
}

export class CommandListProfiles {
  async run(): Promise<Profile[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/profiles/`;
    try {
      return await httpRequest<Profile[]>(url, { method: "GET" });
    } catch (error) {
      console.error("Error fetching profiles:", error);
      throw error;
    }
  }
}
